'use strict';

let requestDataCache = {};

module.exports = class CacheAccessor {
  static get (key) {
    return requestDataCache[key];
  }

  static set (key, value) {
    requestDataCache[key] = value;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/requestDataCache.js